import React, { Component } from 'react';
import { Label, Button } from 'reactstrap';
import CSVReader from "react-csv-reader";

class CVSInput extends Component {
    readFile = data => {
        this.dataFields(false, {});
        this.tableGraph(false, {});
        var csvData = [{}];
        for(var i = 0; i < data[0].length; i++){
            if(data[0][i] !== ""){
                var name = data[0][i];
                csvData.push({value: i, label: name})
            }
        }
        
        //change the text in the box
        var filePath = document.getElementById("csvInput").value;
        var startIndex = (filePath.indexOf('\\') >= 0 ? filePath.lastIndexOf('\\') : filePath.lastIndexOf('/'));
        var filename = filePath.substring(startIndex);
        if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
        }
        document.getElementById("fileName").innerText = filename;
        this.dataFields(true, csvData);
        this.uploadIcon(false);
        this.noGraph(true);
    }

    constructor(props) {
        super(props);
        this.dataFields = this.props.dataFields.bind(this);
        this.noGraph = this.props.noGraph.bind(this);
        this.uploadIcon = this.props.uploadIcon.bind(this);
        this.tableGraph = this.props.tableGraph.bind(this);
    }

    render() {
        return (
            <div>
                <Label>File Upload</Label>
                <CSVReader
                    cssClass="CSV-Reader-Input"
                    inputId="csvInput"
                    onFileLoaded={this.readFile}
                />
                <div>
                    <Button className="Browse-Button">
                        <i className="fas fa-eye Browse-Button-Icon"></i>
                        <span className="Browse-Button-Text">Browse</span>
                    </Button>
                    <span className="fileName" id="fileName"></span>
                </div>
            </div>
        );
    }
}
export default CVSInput;